/**
 * Listener foreground FCM : écoute l'event "fcm-message" (dispatché par
 * fcmService) et affiche un toast Sonner cliquable.
 *
 * Monté une seule fois dans App, après les Providers.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Bell } from 'lucide-react';
import React from 'react';
import fcmService from '../services/fcmService';
import { useAuth } from '../context/AuthContext';

export default function FCMForegroundListener() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return undefined;
    // Tente de restaurer le listener si la permission a déjà été accordée
    fcmService.restoreIfGranted();

    const handler = (event) => {
      const { title, body, url } = event.detail || {};
      toast(title || 'GreenLink', {
        description: body,
        icon: <Bell className="h-4 w-4 text-emerald-600" />,
        duration: 6000,
        action: url
          ? {
              label: 'Voir',
              onClick: () => navigate(url),
            }
          : undefined,
      });
    };

    window.addEventListener('fcm-message', handler);
    return () => window.removeEventListener('fcm-message', handler);
  }, [user, navigate]);

  return null;
}
